import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { supabase } from '../../utils/supabase';

const customStyles = {
  container: (provided) => ({
    ...provided,
    flexGrow: 1,
  }),
  control: (provided) => ({
    ...provided,
    width: '100%',
  }),
};

function CountySelect({ onChange, value }) {
  const [counties, setCounties] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCounties = async () => {
      try {
        const { data } = await supabase
          .from('counties')
          .select('county_name, country_of_county')
          .order('county_name', { ascending: true })
          .range(0, 200); //log data to find why array is empty
        //console.log("data", data); // Check the returned data

        const formattedCounties = (data ?? []).map((county) => ({
          label: county.county_name,
          value: county.county_name,
          country: county.country_of_county, // Include the country information
        }));

        setCounties(formattedCounties);
        //console.log(formattedCounties);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching counties:', error);
      }
    };

    fetchCounties();
  }, []);

  return (
    <>
      <Select
        options={counties}
        value={value}
        isLoading={isLoading}
        placeholder={value}
        onChange={(selectedOption) => {
          //console.log("County selected:", selectedOption);
          onChange({
            label: selectedOption.label,
            value: selectedOption.value,
            country: selectedOption.country, // Pass the country property
          });
        }}
        styles={customStyles}
      />
    </>
  );
}

export default CountySelect;
